// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: 100%;
  width: 100%;

  position: relative;
  display: table;
}

.di-container {
  height: 100%;
  width: 50%;
  position: relative;

  display: table-cell;
  border-collapse: collapse;
}

.di-container.left {
  border-right: dotted 10px #CCC;
}

.di-header {
  position: absolute;
  top: 0;
  z-index: 10;
  margin: 20px;
  padding: 10px;

  background: #EEE;
  border-radius: 5px;

  opacity: 0.9;
}

.di-header:hover {
  opacity: 1;
}

.di-header h2 {
  margin-top: 0;
}

.right .di-header {
  right: 0;
  text-align: right;
}

.canvas {
  display: block;
  height: 100%;
}


.djs-shape.highlight .djs-outline {
  stroke: yellow !important;
  stroke-width: 10px;
  fill: yellow;
}

.djs-container {
  overflow: hidden;
}


/**
 * drag and drop
 */

.drop-marker {
  border: dashed 5px #CCC;
  border-radius: 20px;

  position: absolute;
  left: 20px;
  top: 20px;
  right: 20px;
  bottom: 20px;
}

.di-container .drop-marker,
.di-container.dropping :not(.drop-marker) {
  display: none;
}

.dropping .drop-marker {
  display: block;
}

/**
 * change details
 */
.changeDetails table {
  border: 2px solid orange;
  width: 300px;
  background-color: #fff;
}

.changeDetails th {
  text-align: left;
}


/**
 * markers
 */
.marker {
  border-radius: 50%;
  background-color: gray;
  color: white;
  font-weight: bold;
  font-size: 150%;
  padding-right: 6px;
  padding-left: 6px;
}

.marker-changed {
  font-size: 130%;
  padding: 2px 5px;
}

.marker-layout-changed {
  font-size: 120%;
  padding: 2px 4px;
}


/**
 * changes overview
 */
#changes-overview {
  position: absolute;
  left: 25%;
  right: 25%;
  bottom: 0;
  height: 40%;

  color: #666;

  padding-top: 40px;
  z-index: 110;
}

#changes-overview.collapsed {
  height: 45px;
}

#changes-overview .changes {
  padding: 20px;
  border-radius: 2px 2px 0 0;

  position: relative;
  height: 100%;
  overflow-y: auto;

  background: #F8F8F8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
}

#changes-overview table {
  text-align: left;
  width: 100%;
  height: 100%;

  border-collapse: collapse;
}

#changes-overview table tr {
  line-height: 30px;
}

#changes-overview thead tr {
  border-bottom: solid 1px #999;
}

#changes-overview .entry:hover {
  background-color: #DDD;
  cursor: pointer;
}

#changes-overview .status {
  font-weight: bold;
  color: #F9F9F9;

  padding: 0 5px;
  display: inline-block;
  white-space: nowrap;

  line-height: 20px
}

#changes-overview .entry.removed .status {
  background-color: red;
}

#changes-overview .entry.added .status {
  background-color: green;
}

#changes-overview .entry.changed .status {
  background-color: orange;
}

#changes-overview .entry.layout-changed .status {
  background-color: blue;
}

#changes-overview .show-hide-toggle {
  margin: 0 0 0 auto;
  padding: 5px 10px;
  height: 40px;
  cursor: pointer;
  background: #F0F0F0;
  display: inline-block;
  line-height: 30px;

  position: absolute;
  right: 20px;
  top: 0;

  border-radius: 5px 5px 0 0;
  cursor: pointer;
}

#changes-overview .show-hide-toggle:hover {
  background: #CCC;
}

#changes-overview.collapsed .io-control {
  box-shadow: 0 1px 4px rgba(84, 180, 21, 0.3);
}

#changes-overview.collapsed .show-hide-toggle {
  color: white;
  background: #AAA;
}

#changes-overview.collapsed .show-hide-toggle:hover {
  background: #999;
}

#changes-overview.collapsed .changes {
  overflow: hidden;
  background: #AAA;
}


/**
 * animations
 */

#changes-overview,
#changes-overview.collapsed {
  -webkit-transition: all linear 0.1s;
          transition: all linear 0.1s;
}
`, "",{"version":3,"sources":["webpack://./client/diff/css/app.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;;EAEX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;;EAElB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,gBAAgB;EAChB,kBAAkB;;EAElB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;EAEE;;AAEF;EACE,uBAAuB;EACvB,mBAAmB;;EAEnB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;AACF;EACE,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;EAEE;AACF;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;;EAEE;AACF;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;;EAEX,WAAW;;EAEX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;;EAE1B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;;EAEhB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;;EAEd,cAAc;EACd,qBAAqB;EACrB,mBAAmB;;EAEnB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;;EAEjB,kBAAkB;EAClB,WAAW;EACX,MAAM;;EAEN,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;;EAEE;;AAEF;;EAEE,mCAAmC;UAC3B,2BAA2B;AACrC","sourcesContent":[".content {\n  height: 100%;\n  width: 100%;\n\n  position: relative;\n  display: table;\n}\n\n.di-container {\n  height: 100%;\n  width: 50%;\n  position: relative;\n\n  display: table-cell;\n  border-collapse: collapse;\n}\n\n.di-container.left {\n  border-right: dotted 10px #CCC;\n}\n\n.di-header {\n  position: absolute;\n  top: 0;\n  z-index: 10;\n  margin: 20px;\n  padding: 10px;\n\n  background: #EEE;\n  border-radius: 5px;\n\n  opacity: 0.9;\n}\n\n.di-header:hover {\n  opacity: 1;\n}\n\n.di-header h2 {\n  margin-top: 0;\n}\n\n.right .di-header {\n  right: 0;\n  text-align: right;\n}\n\n.canvas {\n  display: block;\n  height: 100%;\n}\n\n\n.djs-shape.highlight .djs-outline {\n  stroke: yellow !important;\n  stroke-width: 10px;\n  fill: yellow;\n}\n\n.djs-container {\n  overflow: hidden;\n}\n\n\n/**\n * drag and drop\n */\n\n.drop-marker {\n  border: dashed 5px #CCC;\n  border-radius: 20px;\n\n  position: absolute;\n  left: 20px;\n  top: 20px;\n  right: 20px;\n  bottom: 20px;\n}\n\n.di-container .drop-marker,\n.di-container.dropping :not(.drop-marker) {\n  display: none;\n}\n\n.dropping .drop-marker {\n  display: block;\n}\n\n/**\n * change details\n */\n.changeDetails table {\n  border: 2px solid orange;\n  width: 300px;\n  background-color: #fff;\n}\n\n.changeDetails th {\n  text-align: left;\n}\n\n\n/**\n * markers\n */\n.marker {\n  border-radius: 50%;\n  background-color: gray;\n  color: white;\n  font-weight: bold;\n  font-size: 150%;\n  padding-right: 6px;\n  padding-left: 6px;\n}\n\n.marker-changed {\n  font-size: 130%;\n  padding: 2px 5px;\n}\n\n.marker-layout-changed {\n  font-size: 120%;\n  padding: 2px 4px;\n}\n\n\n/**\n * changes overview\n */\n#changes-overview {\n  position: absolute;\n  left: 25%;\n  right: 25%;\n  bottom: 0;\n  height: 40%;\n\n  color: #666;\n\n  padding-top: 40px;\n  z-index: 110;\n}\n\n#changes-overview.collapsed {\n  height: 45px;\n}\n\n#changes-overview .changes {\n  padding: 20px;\n  border-radius: 2px 2px 0 0;\n\n  position: relative;\n  height: 100%;\n  overflow-y: auto;\n\n  background: #F8F8F8;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);\n}\n\n#changes-overview table {\n  text-align: left;\n  width: 100%;\n  height: 100%;\n\n  border-collapse: collapse;\n}\n\n#changes-overview table tr {\n  line-height: 30px;\n}\n\n#changes-overview thead tr {\n  border-bottom: solid 1px #999;\n}\n\n#changes-overview .entry:hover {\n  background-color: #DDD;\n  cursor: pointer;\n}\n\n#changes-overview .status {\n  font-weight: bold;\n  color: #F9F9F9;\n\n  padding: 0 5px;\n  display: inline-block;\n  white-space: nowrap;\n\n  line-height: 20px\n}\n\n#changes-overview .entry.removed .status {\n  background-color: red;\n}\n\n#changes-overview .entry.added .status {\n  background-color: green;\n}\n\n#changes-overview .entry.changed .status {\n  background-color: orange;\n}\n\n#changes-overview .entry.layout-changed .status {\n  background-color: blue;\n}\n\n#changes-overview .show-hide-toggle {\n  margin: 0 0 0 auto;\n  padding: 5px 10px;\n  height: 40px;\n  cursor: pointer;\n  background: #F0F0F0;\n  display: inline-block;\n  line-height: 30px;\n\n  position: absolute;\n  right: 20px;\n  top: 0;\n\n  border-radius: 5px 5px 0 0;\n  cursor: pointer;\n}\n\n#changes-overview .show-hide-toggle:hover {\n  background: #CCC;\n}\n\n#changes-overview.collapsed .io-control {\n  box-shadow: 0 1px 4px rgba(84, 180, 21, 0.3);\n}\n\n#changes-overview.collapsed .show-hide-toggle {\n  color: white;\n  background: #AAA;\n}\n\n#changes-overview.collapsed .show-hide-toggle:hover {\n  background: #999;\n}\n\n#changes-overview.collapsed .changes {\n  overflow: hidden;\n  background: #AAA;\n}\n\n\n/**\n * animations\n */\n\n#changes-overview,\n#changes-overview.collapsed {\n  -webkit-transition: all linear 0.1s;\n          transition: all linear 0.1s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
